import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { computed, defineComponent, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "GenericFilterDropdownMenu",
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    showAllOption: {
      type: Boolean,
      default: false
    },
    allowSearch: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    idKey: {
      type: String,
      default: ""
    }
  },
  setup(props, {
    emit
  }) {
    const {
      tc
    } = useI18n();
    const selectAllOption = {
      key: props.idKey,
      value: "",
      name: tc("global.words.all", 1)
    };
    const computedOptions = computed(() => {
      const options = [...props.options];
      if (props.showAllOption) {
        options.unshift(selectAllOption);
      }
      return options;
    });
    const valueModel = computed({
      get() {
        return props.value;
      },
      set(selectedOptions) {
        if (!props.showAllOption) {
          return emit("input", selectedOptions);
        }
        const lastOption = selectedOptions[selectedOptions.length - 1];
        if (lastOption === selectAllOption.value) {
          emit("input", [selectAllOption.value]);
        } else {
          emit("input", _filterInstanceProperty(selectedOptions).call(selectedOptions, selection => selection !== selectAllOption.value));
        }
      }
    });
    const searchString = ref("");
    const filteredOptions = computed(() => {
      var _context;
      if (!props.allowSearch || !searchString.value) return computedOptions.value;
      return _filterInstanceProperty(_context = computedOptions.value).call(_context, ({
        name
      }) => {
        var _context2, _searchString$value;
        return _includesInstanceProperty(_context2 = name.toLowerCase()).call(_context2, (_searchString$value = searchString.value) == null ? void 0 : _searchString$value.toLowerCase());
      });
    });
    return {
      filteredOptions,
      valueModel,
      searchString
    };
  }
});